import { Component, OnInit } from "@angular/core";
import { UtilService } from "src/app/service/util.service";
import * as CONSTANTS from '../../constants';

import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ValidateEmail, ValidatePhoneNumber } from "../validators/personalInfo-contact.validators";
import { PREQUAL_DATA } from "../../dummy_data/dummy_prequalData";

export enum UI_GENERATION {
    BORROWER = 'Borrower',
    CO_BORROWER = 'Co_Borrower',
    BOTH = 'Both'
}

@Component({
    selector: 'personal-information-contact_update',
    styleUrls: ['./personal-information-contact_update.less'],
    templateUrl: './personal-information-contact_update.html'
})


export class personalInformationContactUpdatedComponent implements OnInit {
    preQualObj: any;
    nextProgressPercent: CONSTANTS.PROGRESS_PERCENTAGE;
    infoForm: FormGroup;
    UI_For: string = UI_GENERATION.BORROWER;
    UI_data = { mobileNumber: '', eMail: '', co_mobileNumber: '', co_eMail: '' };
    loader: boolean = true;
    showForm: boolean;
    UI_GEN = UI_GENERATION;
    constructor(private util: UtilService) { }

    ngOnInit(): void {
        this.setDefaultValues();
        this.setTestData()
        this.getPrequalInfo();
        this.createFormGrpChangeEvent();
        this.setAndGetPercentage();
        this.loader = false;
        this.showForm = true;
        console.log(' PREQUAL_DATA --- > ', PREQUAL_DATA);
        console.log(' form grp -- > ', this.infoForm);
    }

    createFormGrpChangeEvent() {
        if (this.infoForm !== null) {
            this.infoForm.valueChanges.subscribe(obj => {
            })
        }
    }

    setDefaultValues() {
        this.infoForm = null;
    }

    setTestData() {
        this.util.setSessionStorage(PREQUAL_DATA)
    }

    getPrequalInfo() {
        this.preQualObj = this.util.getSessionStorage();
        this.UI_For = UI_GENERATION.BOTH;
        this.getDataForScreen();
        if (this.UI_For === UI_GENERATION.BORROWER) {
            this.createFormGrp();
        } else if (this.UI_For === UI_GENERATION.CO_BORROWER) {
            this.createFormGrp('co_mobileNumber', 'co_eMail');
        } else if (this.UI_For === UI_GENERATION.BOTH) {
            this.createFormGrp();
            this.createFormGrp('co_mobileNumber', 'co_eMail');
        }
    }
    getDataForScreen() {
        let userId = (this.UI_For === UI_GENERATION.BORROWER) ? 0
            : (this.UI_For === UI_GENERATION.CO_BORROWER) ? 1 : null;
        if (userId == null) {
            this.setValueIN_UIData(0);
            this.setValueIN_UIData(1);
        } else {
            this.setValueIN_UIData(userId);
        }
    }

    setValueIN_UIData(userId) {
        let curUser = this.preQualObj.users.filter(obj => obj.main_application === userId)[0];
        this.UI_data[(userId === 0) ? 'mobileNumber' : 'co_mobileNumber'] = curUser.homenumber;
        this.UI_data[(userId === 0) ? 'eMail' : 'co_eMail'] = curUser.email;
    }
    onCancel() {

    }
    onContinue() {
        let ctrKeys = Object.keys(this.infoForm.controls);
        ctrKeys.forEach(obj => {
            if (this.infoForm.get(obj).invalid) {
                this.infoForm.get(obj).markAsDirty();
                this.infoForm.get(obj).markAsTouched();
                document.getElementById(obj).focus();
            }
        })
        // if (this.infoForm.valid) {
        //     ctrKeys.forEach(obj => {
        //         let curObj: any;
        //         if (obj.indexOf("co_") > -1) {
        //             curObj = PREQUAL_DATA.users2.find(obj => obj.main_application == 1);
        //         } else {
        //             curObj = PREQUAL_DATA.users2.find(obj => obj.main_application == 0);
        //         }
        //         this.setUpdateValue(curObj, obj, this.infoForm.get(obj).value)
        //     })
        // }
        console.log(' PREQUAL_DATA --- > ', PREQUAL_DATA);
    }

    setUpdateValue(curPeQalObj: any, key: string, value: any) {
        if (key.indexOf('eMail') > -1) {
            curPeQalObj.email = value;
        } else {
            curPeQalObj.homenumber = value;
        }
    }
    createFormGrp(mobile: string = 'mobileNumber', email: string = 'eMail') {
        this.infoForm = (this.infoForm == null) ? new FormGroup({}) : this.infoForm;
        this.infoForm.addControl(mobile, new FormControl(this.UI_data[mobile], [Validators.required, ValidatePhoneNumber]));
        this.infoForm.addControl(email, new FormControl(this.UI_data[email], [Validators.required,
        Validators.pattern("^[a-zA-Z0-9_-]+(?:\\.[a-zA-Z0-9_-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]\\.)+([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])$"), ValidateEmail]));
    }

    setAndGetPercentage() {
        this.util.sidebarTitle.next('slideTitles.personalInfo');
        let progressPercent1 = sessionStorage.getItem("progressPercentage");
        if (Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.NEW_CUSTOMER_TELL_US_ABOUT_YOURSELF_PRIMARY
            || Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.NEW_CUSTOMER_TELL_US_ABOUT_YOURSELF_2_CUSTOMER ||
            Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.NEW_CUSTOMER_1_TELL_US_ABOUT_YOURSELF_PRIMARY ||
            Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.CONSENT_PRIMARY ||
            sessionStorage.getItem("routeBack") == "true") {
            let progressPrcnt = (this.preQualObj.is_coapplicant_applied == "Y") ?
                CONSTANTS.PROGRESS_PERCENTAGE.NEW_CUSTOMER_CONTACT_DETAILS_PRIMARY :
                CONSTANTS.PROGRESS_PERCENTAGE.NEW_CUSTOMER_1_CONTACT_DETAILS_PRIMARY;
            this.nextProgressPercent = progressPrcnt;
            if (this.preQualObj.users.length == 2) {
                progressPrcnt = CONSTANTS.PROGRESS_PERCENTAGE.NEW_CUSTOMER_CONTACT_DETAILS_2_CUSTOMER;
                this.util.sidebarTitle.next('slideTitles.coApplicantInfo');
            }
            this.util.progressPercent.next(progressPrcnt);
        }
    }
}